// core components
import withStyles from "@material-ui/core/styles/withStyles";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import axios from 'axios';
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import PropTypes from "prop-types";
import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from 'react-redux';
import { api_url } from 'redux/config.js';
import { verifyEmail } from "utils/Validate";
import Toast from 'views/Toast/Toast';
import SurveyMainComponent from "./components/SurveyMainComponent";
import SurveyProgress from "./components/SurveyProgress";
import SurveyScore from "./components/SurveyScore"
import LanguageSelector from "views/Survey/components/LanguageSelector"
import * as Score from "utils/Score";

import pagesStyle from "layouts/PublicLayout.style";
import { withTranslation } from "react-i18next";
import i18next, { t } from "i18next";
import { CallApi } from "utils/Request";
const styles = (theme) => ({
  ...sweetAlertStyle,
  ...pagesStyle(theme),
  surveyImg: {
    width: "100%"
  }
})
class SingleSurveyPage extends React.Component {
  constructor(props) {
    super(props);
    // Per-location QR codes carry the location/Σημείο in the query string (?location=205).
    // When present the guest never types it — it is attached silently to the response.
    const search = (this.props.location && this.props.location.search) || (typeof window !== 'undefined' ? window.location.search : '') || '';
    let locationTag = '';
    try {
      locationTag = (new URLSearchParams(search).get('location') || '').trim();
    } catch (e) {
      locationTag = '';
    }
    this.state = {
      selectedLanguage: '',
      // Until the guest has picked a language (surveys with several), the page shows a language
      // choice instead of the questionnaire. Ordering: any email/room/password prompt overlays
      // first, so the guest answers that, then chooses a language, then sees the questions.
      languageChosen: false,
      survey_completed: false,
      survey_id: this.props.match.params.survey_id,
      survey_type: this.props.match.params.survey_type, // email, nocondition, password
      locationTag,
      data: null,
      takenAlready: false,
      email: '',
      freeid: '',
      conditionInput: {

      }
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.style.overflow = "unset";
    this.onLoad(this.state.survey_id);
    // Skip the prompt entirely when the location is already known from the QR and the survey
    // only asks for the location (freeid). Email/password links still prompt as before.
    const knownLocation = this.state.survey_type === 'freeid' && this.state.locationTag;
    if (this.state.survey_type !== 'nocondition' && !knownLocation) {
      this.basicAlert();
    }
  }

  onComplete = (answers) => {
    let self = this;
    const url = api_url + `survey/complete`;
    const header = 'Bearer '.concat(this.props.user.token);
    let headers = null;
    let data = {
      survey: this.state.data.id,
      survey_type: this.state.survey_type,
      email: this.state.conditionInput.email,
      freeid: this.state.conditionInput.freeid,
      password: this.state.conditionInput.password,
      location: this.state.locationTag,
      answers: answers,
      language: this.state.data.main[0].language
    }

    if (this.props.user.token) {
      headers = {
        Authorization: header
      };
    }
    this.props.dispatch({ type: 'LOAD_START' });
    axios({
      url,
      method: 'post',
      headers,
      data
    })
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            survey_completed: true,
            answers: answers
          })
          self.sendRateMessage(data.survey, response.data.newresponse.id, answers)

        } else {
          Toast(400, response.data.error)
        }
        self.props.dispatch({ type: 'LOAD_END' });
      })
      .catch(function (errors) {
        console.info(errors);
        self.props.dispatch({ type: 'LOAD_END' });
        if (!errors.response) {
          Toast(500);
          return;
        }
        Toast(errors.response.status);
      });
  };
  sendRateMessage = (survey_id, response_id, answers) => {
    const { data, selectedLanguage } = this.state

    const dataLang = this.getDataOfLang(selectedLanguage)

    const questions = dataLang.questions
    CallApi({
      url: 'rate_message/send_message',
      method: 'post',
      data: {
        survey: survey_id,
        response_id: response_id,
        score: Score.getScoreOfOneResponse(questions, answers)
      }
    }).then((res) => {
      console.info('=== called rate message ===', JSON.stringify(res, null, 4))
    })
  }
  onLoad = (survey_id) => {
    let self = this;
    const url = api_url + `survey/get`;
    const params = {
      id: survey_id
    }

    this.props.dispatch({ type: 'LOAD_START' });
    axios({
      url,
      method: 'get',
      params
    })
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            data: response.data.data
          });
          try {
            const first = (response.data.data.main[0] || {}).language
            if (first) i18next.changeLanguage(first)
          } catch (e) { /* ignore */ }
        } else {
          Toast(400, response.data.error);
        }
        self.props.dispatch({ type: 'LOAD_END' });
      })
      .catch(function (errors) {
        console.info(errors);
        self.props.dispatch({ type: 'LOAD_END' });
        if (!errors.response) {
          Toast(500);
          return;
        }
        Toast(errors.response.status);
      });
  };


  confirmCondition = () => {
    const survey_type = this.state.survey_type
    if (survey_type === 'email') {
      if (!verifyEmail(this.state.conditionInput.email)) {
        Toast(400, t('Invalid email format'))
      } else {
        this.hideAlert()
      }
    }

    if (survey_type === 'password') {
      const passwords = this.state.data.passwords
      if (!passwords || passwords.length === 0) return
      const matches = passwords.filter((item) => item.password == this.state.conditionInput.password);
      if (matches.length > 0) {
        const matched = matches[0];
        if (matched.used) {
          Toast(400, t('This password already used'))
          return
        }
        const now = Date.now();
        if (now > new Date(matched.expire_date)) {
          Toast(400, t('Password expired')); return
        }
        this.hideAlert()
      } else {
        Toast(400, t('Incorrect password'))
      }
    }
    if (survey_type === 'freeid') {
      this.hideAlert()
    }
  }
  basicAlert = () => {
    const survey_type = this.state.survey_type
    let title = '';
    let label = '';
    if (survey_type === 'email') {
      title = t('Please enter email')
      label = t('Email')
    }

    if (survey_type === 'freeid') {
      title = "Room number | Αριθμός δωματίου | Zimmernummer"
      label = "Room number | Αριθμός δωματίου | Zimmernummer"
    }
    if (survey_type === 'password') {
      title = t('Please enter password')
      label = t('Password')
    }
    this.setState({
      alert: (
        <SweetAlert
          style={{
            display: "block",
            top: "20%",
            marginTop: 0,
            color: 'black'
          }}
          title={title}
          showConfirm={true}
          onConfirm={() => this.confirmCondition()}

          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        >

          <CustomInput
            labelText={label}
            id="campaignname"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: "text",
              onChange: (e) => this.setState({
                conditionInput: {
                  [survey_type]: e.target.value
                }
              }),
            }}
          />
        </SweetAlert>
      )
    });
  };
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  onChangeLanguage = (language) => {
    this.setState({
      selectedLanguage: language
    })
    // The page chrome (Next Section, validation messages, ...) must speak the same language as the
    // questionnaire the guest chose — not whatever the browser happened to be in.
    try { i18next.changeLanguage(language) } catch (e) { /* never break answering over locale */ }
  }
  getDataOfLang = (language) => {
    const { data, } = this.state

    let main = data.main[0]
    let questions = data.questions[0]
    if (language.length > 0) {
      let mainfiltered = data.main.filter(item => item.language === language)[0]
      let questionsfiltered = data.questions.filter(item => item.language === language)[0]
      main = mainfiltered ? mainfiltered : data.main[0]
      questions = questionsfiltered ? questionsfiltered : data.main[0]
    }
    return {
      main, questions
    }
  }
  render() {
    const { classes } = this.props;
    const { data, survey_completed, answers, selectedLanguage } = this.state

    if (!data) return <div>{t('Loading')} ...</div>;

    // Language first (or right after the email/room/password prompt, which overlays this screen):
    // a survey stored in several languages asks which one before showing any question. A survey in
    // one language skips this entirely.
    const availableLangs = data.main.map(item => item.language)
    if (!survey_completed && !this.state.languageChosen && availableLangs.length > 1) {
      const PICK = { el: 'Επιλέξτε γλώσσα', en: 'Select your language', de: 'Sprache wählen', fr: 'Choisissez votre langue', es: 'Elija su idioma', pt: 'Escolha o seu idioma', sq: 'Zgjidhni gjuhën', uk: 'Оберіть мову' }
      return <div className={classes.wrapper} ref="wrapper">
        <div className={classes.fullPage}>
          <GridContainer justify="center">
            {this.state.alert}
            <GridItem sm={6} xs={12}>
              <SurveyMainComponent data={{ image_url: data.image_url, ...this.getDataOfLang('').main, description: '' }} />
              <div style={{ textAlign: 'center', margin: '4px 0 10px' }}>
                {availableLangs.map(l => PICK[l]).filter((v, i, a) => v && a.indexOf(v) === i).map((line, i) =>
                  <div key={i} style={{ fontSize: 15, color: '#555', lineHeight: 1.7 }}>{line}</div>)}
              </div>
              <LanguageSelector direction={'vertical'} value={''} languages={availableLangs}
                onChange={(language) => { this.setState({ languageChosen: true }); this.onChangeLanguage(language) }} />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    }

    const dataLang = this.getDataOfLang(selectedLanguage)
    const mainData = {
      image_url: data.image_url,
      ...dataLang.main
    }
    const questions = dataLang.questions

    if (survey_completed) {
      return <div className={classes.wrapper} ref="wrapper">
        <div className={classes.fullPage}><SurveyScore endMessages={data.endmessages} answers={answers} questions={questions} placeId={data.google_place_id} reviewLinks={data.review_links} lang={dataLang.main.language} />
        </div>
      </div>
    }
    return (

      <div className={classes.wrapper} ref="wrapper">
        <div className={classes.fullPage}>
          <GridContainer>
            {this.state.alert}
            <GridItem sm={12} xs={12}>
              <LanguageSelector direction={'horizontal'} value={dataLang.main.language} languages={data.main.map(item => item.language)} onChange={(language) => this.onChangeLanguage(language)} />
              <SurveyMainComponent data={mainData} />
            </GridItem>
            <GridItem sm={12} xs={12}>
              <SurveyProgress doRefresh={selectedLanguage} questions={questions} saveAnswer={(answers) => this.onComplete(answers)} />
            </GridItem>
          </GridContainer>
        </div></div>
    );
  }
}

SingleSurveyPage.propTypes = {
  classes: PropTypes.object.isRequired
};


const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(SingleSurveyPage)));